import { render, staticRenderFns } from "./salesProjectReports.vue?vue&type=template&id=6ed481cb&scoped=true&"
import script from "./salesProjectReports.vue?vue&type=script&lang=js&"
export * from "./salesProjectReports.vue?vue&type=script&lang=js&"
import style0 from "./salesProjectReports.vue?vue&type=style&index=0&id=6ed481cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed481cb",
  null
  
)

export default component.exports